import { Instance, types } from 'mobx-state-tree';

import AlertStore from './AlertStore';
import AuthStore from './AuthStore';
import ConfigStore from './ConfigStore';
import MeStore from './MeStore';
import MusicStore from './MusicStore';
import PlaybackStore from './PlaybackStore';
import SearchStore from './SearchStore';
import UserStore from './UserStore';

const RootStore = types.model('RootStore', {
    auth: types.optional(AuthStore, {}),
    me: types.optional(MeStore, {}),
    playback: types.optional(PlaybackStore, {}),
    music: types.optional(MusicStore, {}),
    alerts: types.optional(AlertStore, {}),
    search: types.optional(SearchStore, {}),
    users: types.optional(UserStore, {}),
    config: types.optional(ConfigStore, {}),
});

export interface IRootStore extends Instance<typeof RootStore> {}

export default RootStore;
